import { render } from "./TakEoutburgert.vue?vue&type=template&id=ff56aba2"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEoutburgert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff56aba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff56aba2', __exports__)) {
    api.reload('ff56aba2', __exports__)
  }
  
  module.hot.accept("./TakEoutburgert.vue?vue&type=template&id=ff56aba2", () => {
    api.rerender('ff56aba2', render)
  })

}


export default __exports__